import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useAuth } from "../../lib/auth-context.js";

export const Route = createFileRoute("/_app/onboarding")({
  component: OnboardingPage,
});

function OnboardingPage() {
  const { workspace } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="brut-card" style={{ maxWidth: 560, margin: "0 auto" }}>
      <h1 style={{ fontSize: 36, fontWeight: 900, letterSpacing: "-0.03em", margin: "0 0 16px" }}>
        Welcome to {workspace?.name ?? "OyeReply"}
      </h1>
      <p>
        Your personal workspace is ready. From here you can connect an
        Instagram account, build flows, and reply to DMs at scale.
      </p>
      <p style={{ color: "var(--muted)", marginBottom: 32 }}>
        Want to invite teammates? Create a separate team workspace from
        Settings — keep your personal sandbox tidy.
      </p>
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        <button
          type="button"
          className="brut-button"
          onClick={() => navigate({ to: "/dashboard" })}
        >
          Go to dashboard
        </button>
        <button
          type="button"
          className="brut-button is-secondary"
          onClick={() => navigate({ to: "/settings/workspaces" })}
        >
          Workspace settings
        </button>
      </div>
    </div>
  );
}
